module.exports = "//static.hsappstatic.net/LoginUI/static-1.15875/img/passkey-logo.svg"